module.exports = __webpack_public_path__ + "img/ptt-evolution.6611f70d.svg";